import { MIXPANEL_TOKEN } from '@/constants/common';
import mixpanel from 'mixpanel-browser';

const env_check = true; // change this later for prod and dev env

mixpanel.init(MIXPANEL_TOKEN, {
  api_host: 'https://api-eu.mixpanel.com', // This need to be change in the production
  debug: true,
});

const actions = {
  identify: (id: string | undefined) => {
    if (env_check) mixpanel?.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel?.alias(id);
  },
  track: (name: string, props?: Record<string, unknown>) => {
    if (env_check) mixpanel?.track(name, props);
  },
  people: {
    set: (props: Record<string, unknown>) => {
      if (env_check) mixpanel?.people.set(props);
    },
  },
};

export const Mixpanel = actions;
